var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandHammerBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hammer",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    id: "Path_8",
    className: "st0",
    d: "M34.2,12.6c-0.4-0.4-1.1-0.4-1.5,0c0,0,0,0,0,0c-0.4,0.4-1.1,0.4-1.5,0c-0.4-0.4-0.4-1.1,0-1.5 l0,0l-6,6c0.4-0.4,1.1-0.4,1.5,0c0.4,0.4,0.4,1.1,0,1.5c-0.4,0.4-0.4,1.1,0,1.5c0,0,0,0,0,0l1.5,1.5c0.4,0.4,1.1,0.4,1.5,0 c0,0,0,0,0,0l6-6c0.4-0.4,0.4-1.1,0-1.5c0,0,0,0,0,0L34.2,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st0",
    d: "M20,10.3l4.5,4.5l5.2-5.2c0.4-0.4,0.4-1.1,0-1.5c0,0,0,0,0,0l-3-3c-4-4-10.3-6.1-14.9-1.5 c-0.4,0.4-0.4,1.1,0,1.5c0.2,0.2,0.5,0.3,0.7,0.3c3.2,0,6.4,1.2,8.8,3.3c0.1,0.1,0.1,0.2,0,0.3L20,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    className: "st0",
    d: "M0.9,33.9c1.2,1.2,3.2,1.2,4.5,0L23,16.3l-4.5-4.5L0.9,29.4C-0.3,30.7-0.3,32.7,0.9,33.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHammerBlu);
export default __webpack_public_path__ + "static/media/hand-hammer-blu.f018ef4b.svg";
export { ForwardRef as ReactComponent };